import { ArrayPath } from './ArrayPath'
import { getArrayPath } from './getArrayPath'

/**
 * Check if path starts with searchPath.
 */
export const pathStartsWith = (
  path: string | ArrayPath,
  searchPath: string | ArrayPath,
  format: 'js' | 'json' | 'jsonata' | 'dot' | 'detect' = 'detect'
) => {
  path = typeof path === 'string' ? getArrayPath(path, format) : path
  searchPath =
    typeof searchPath === 'string'
      ? getArrayPath(searchPath, format)
      : searchPath

  if (!path.length) {
    return false
  }

  if (path.length < searchPath.length) {
    return false
  }

  if (searchPath.some((p, i) => p !== path[i])) {
    return false
  }

  return true
}
